// document.addEventListener("DOMContentLoaded", function () {
//   if (window.innerWidth > 768) return; // mobile-only

//   const blocks = document.querySelectorAll(".footer__block");

//   blocks.forEach(block => {
//     const title = block.querySelector(".h6");
//     if (!title) return;

//     // Add toggle icon
//     const icon = document.createElement("span");
//     icon.className = "footer-toggle-icon";
//     icon.innerHTML = "+"; // default, closed
//     title.appendChild(icon);

//     title.addEventListener("click", () => {
//       block.classList.toggle("active");

//       // Switch + / -
//       icon.innerHTML = block.classList.contains("active") ? "–" : "+";
//     });
//   });
// });

(function () {
  function initFooterAccordions() {
    if (!window.matchMedia || window.matchMedia('(min-width: 769px)').matches) return;

    var blocks = document.querySelectorAll('.footer__block');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var title = block.querySelector('.h6');
      if (!title) return;

      // Avoid double-binding in case of Ajax loads
      if (title.dataset.footerAccordionBound === 'true') return;
      title.dataset.footerAccordionBound = 'true';

      var icon = document.createElement('span');
      icon.className = 'footer-toggle-icon';
      icon.innerHTML = '+';
      title.appendChild(icon);

      title.addEventListener('click', function () {
        var isActive = block.classList.toggle('active');
        icon.innerHTML = isActive ? '–' : '+';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initFooterAccordions);
    } else {
      setTimeout(initFooterAccordions, 0);
    }
  });
})();